import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Core_Escrow_Release_Request.css';

const Core_Escrow_Release_Request = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"CORE_ESCROW_RELEASE_REQUEST",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	CORE_ESCROW_RELEASE_REQUEST:-1
  });


  const [CORE_ESCROW_RELEASE_REQUEST, setCORE_ESCROW_RELEASE_REQUEST] = React.useState(null);
  const [CORE_ESCROW_RELEASE_REQUEST_D, setCORE_ESCROW_RELEASE_REQUEST_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Core Escrow Release Request');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewCORE_ESCROW_RELEASE_REQUEST(clientInfo,"OpenNew");

		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Escrow_Release_Request_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutCORE_ESCROW_RELEASE_REQUEST(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostCORE_ESCROW_RELEASE_REQUEST(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewCORE_ESCROW_RELEASE_REQUEST(clientInfo,"OpenNew");
		}
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Escrow_Release_Request_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Escrow_Release_Request_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Escrow_Release_Request_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
		if(Temp_Data2.status!="New"){
			handleDeleteCORE_ESCROW_RELEASE_REQUEST(Temp_Data2);
			navigate('/Core_Escrow_Release_Request#New',{replace:true});
		} 
		else 
			navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!CORE_ESCROW_RELEASE_REQUEST) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [CORE_ESCROW_RELEASE_REQUEST]) ;


  
  
  var Ids = [];
  for(var Ele in CORE_ESCROW_RELEASE_REQUEST){
	  for(var Sec in CORE_ESCROW_RELEASE_REQUEST[Ele]){
		if(Sec == "id")
			Ids.push(CORE_ESCROW_RELEASE_REQUEST[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(CORE_ESCROW_RELEASE_REQUEST[Ele]["status"]);
		else if(Array.isArray(CORE_ESCROW_RELEASE_REQUEST[Ele][Sec]))
			  for(var Row in CORE_ESCROW_RELEASE_REQUEST[Ele][Sec])  // Convert to CORE_ESCROW_RELEASE_REQUEST[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in CORE_ESCROW_RELEASE_REQUEST[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["CORE_ESCROW_RELEASE_REQUEST"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewCORE_ESCROW_RELEASE_REQUEST(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_ESCROW_RELEASE_REQUEST`).then((response1) => {
		if(!CORE_ESCROW_RELEASE_REQUEST) 
			setCORE_ESCROW_RELEASE_REQUEST(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_ESCROW_RELEASE_REQUEST_D`).then((response2) => {
			setCORE_ESCROW_RELEASE_REQUEST_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddCORE_ESCROW_RELEASE_REQUEST_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewCORE_ESCROW_RELEASE_REQUEST = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_ESCROW_RELEASE_REQUEST/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setCORE_ESCROW_RELEASE_REQUEST(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataCORE_ESCROW_RELEASE_REQUEST = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_ESCROW_RELEASE_REQUEST/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutCORE_ESCROW_RELEASE_REQUEST = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_ESCROW_RELEASE_REQUEST/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostCORE_ESCROW_RELEASE_REQUEST = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_ESCROW_RELEASE_REQUEST', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteCORE_ESCROW_RELEASE_REQUEST = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_ESCROW_RELEASE_REQUEST', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["2"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("2","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["2"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("2","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["3"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("3","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["3"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("3","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  

const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["4"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0"]=value;
	Form_Data_onChange("4","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
  }; 
  

    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["5"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("5","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["5"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("5","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["5"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("5","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["5"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("5","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  

const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["5"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4"]=value;
	Form_Data_onChange("5","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
  }; 
  

    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["5"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("5","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  

const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
  }; 
  

    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!CORE_ESCROW_RELEASE_REQUEST) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedCORE_ESCROW_RELEASE_REQUEST =JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
  updatedCORE_ESCROW_RELEASE_REQUEST[Sec] = [...updatedCORE_ESCROW_RELEASE_REQUEST[Sec], newRow];
  setCORE_ESCROW_RELEASE_REQUEST(updatedCORE_ESCROW_RELEASE_REQUEST);
};

const handleDeleteRow = (sec,index) => {
  const updatedCORE_ESCROW_RELEASE_REQUEST = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
  updatedCORE_ESCROW_RELEASE_REQUEST[sec].splice(index, 1);
  setCORE_ESCROW_RELEASE_REQUEST(updatedCORE_ESCROW_RELEASE_REQUEST);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Core Escrow Release Request`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Escrow Release Request ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Release Request ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0" type="text" className="form-control" placeholder="Escrow Release Request ID" value={CORE_ESCROW_RELEASE_REQUEST["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Escrow Release Request ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Account ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1" type="text" className="form-control" placeholder="Escrow Account ID" value={CORE_ESCROW_RELEASE_REQUEST["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Escrow Account ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2" type="text" className="form-control" placeholder="Offering ID" value={CORE_ESCROW_RELEASE_REQUEST["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Milestone ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3" type="text" className="form-control" placeholder="Milestone ID" value={CORE_ESCROW_RELEASE_REQUEST["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Milestone ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Requested Amount USD`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Requested Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0" type="text" className="form-control" placeholder="Requested Amount USD" value={CORE_ESCROW_RELEASE_REQUEST["2"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Requested Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Requested By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1" type="text" className="form-control" placeholder="Requested By" value={CORE_ESCROW_RELEASE_REQUEST["2"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Requested By`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Request Reason`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Request Reason`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0" type="text" className="form-control" placeholder="Request Reason" value={CORE_ESCROW_RELEASE_REQUEST["3"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Request Reason`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Supporting Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1" type="text" className="form-control" placeholder="Supporting Document Link" value={CORE_ESCROW_RELEASE_REQUEST["3"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Supporting Document Link`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Release Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Release Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0"  value={CORE_ESCROW_RELEASE_REQUEST["4"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0`]} onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0_Change} className="form-control" name="Release Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Requested">Requested</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Released">Released</option>
						  <option value="Cancelled">Cancelled</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Release Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0" type="text" className="form-control" placeholder="Submitted By" value={CORE_ESCROW_RELEASE_REQUEST["5"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1" type="text" className="form-control" placeholder="Submitted At" value={CORE_ESCROW_RELEASE_REQUEST["5"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2" type="text" className="form-control" placeholder="Reviewed By" value={CORE_ESCROW_RELEASE_REQUEST["5"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3" type="text" className="form-control" placeholder="Reviewed At" value={CORE_ESCROW_RELEASE_REQUEST["5"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4"  value={CORE_ESCROW_RELEASE_REQUEST["5"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4`]} onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5" type="text" className="form-control" placeholder="Approval Notes" value={CORE_ESCROW_RELEASE_REQUEST["5"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0"  value={CORE_ESCROW_RELEASE_REQUEST["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0`]} onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1" type="text" className="form-control" placeholder="Created By" value={CORE_ESCROW_RELEASE_REQUEST["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2" type="text" className="form-control" placeholder="Created At" value={CORE_ESCROW_RELEASE_REQUEST["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3" type="text" className="form-control" placeholder="Updated By" value={CORE_ESCROW_RELEASE_REQUEST["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4" type="text" className="form-control" placeholder="Updated At" value={CORE_ESCROW_RELEASE_REQUEST["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Core_Escrow_Release_Request;  